import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

// Data
import Navigation from '../../data/Navigation.json';

class HeaderNavigation extends Component {
    render () {

        function openMobileNav(e) {
            document.body.classList.toggle('show-nav');
            e.preventDefault();
        }
        function closeMobileNav(e) {
            document.body.classList.remove('show-nav');
        }

        return (
            <div className="main-nav">
                <div>
                    <ul>
                        {
                            Navigation.header.map((item,i) => {
                                return (
                                     <li key={i}><NavLink onClick={closeMobileNav} className={item.classes} to={item.path}>{item.name}</NavLink></li>
                                );

                            })

                        }
                    </ul>
                </div>
                <button 
                    onClick={openMobileNav}
                    className="menu-toggle"
                >
                    <span></span>
                </button>
            </div>
        );
    }
}

export default HeaderNavigation;


// WEBPACK FOOTER //
// ./src/containers/Header/HeaderNavigation.js